import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  headerWrapper: {
    width: 720,
    margin: '0 auto',
    paddingBottom: theme.spacing(1)
  },
  titleWrapper: {
    paddingTop: 0
  },
  subtitle: {
    paddingRight: 10
  }
}));

export default useStyles;
